import React, { Component } from 'react'
import moment from "moment"
import mlocale from 'antd/lib/date-picker/locale/zh_CN'
import { Row, Col, Form, Radio, DatePicker, Upload, Select, Cascader, Spin, Button } from 'antd'
import { app, api, config } from "../../app"

const FormItem = Form.Item
const Option = Select.Option
const RadioGroup = Radio.Group


/**
 * 上传之前
 * @param file
 * @returns {boolean}
 */
function beforeUpload (file) {
    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
        app.alert('头像图片最大2MB!', 'warn')
    }
    return isLt2M
}

class PpeAdd extends Component {
    constructor (props) {
        super(props)
        this.state = {
            org_loading: true,
            submit_loading: false,
            organizationList: [],
        }
    }

    async componentDidMount () {
        this._isMounted = true
        if (this.props.is_edit && this.props.info.ppe_id) {
            await this.PpeOrganizationSource(this.props.info.ppe_id[0])
        }
    }

    componentWillUnmount () {
        this._isMounted = false
    }

    setData = (data) => app.setStateSync(this, data)

    /**
     * 提交信息
     * @param e
     */
    handleSubmit = async (e) => {
        if (this.state.submit_loading) return false
        e.preventDefault()
        this.props.form.validateFields(async (err, { get_time, ppe_id, url, is_long, expire_time, organization_id }) => {
            if (!err) {
                await this.setData({ submit_loading: true })
                let params = {
                    organization_id,
                    indexno: app.getData('indexno'),
                    account: app.getData('account'),
                }
                params.get_time = get_time.format('YYYY-MM-DD')
                params.is_long = is_long
                if (is_long === '1') {
                    params.expire_time = expire_time.format('YYYY-MM-DD')
                }
                params.ppe_id = ppe_id[ppe_id.length - 1]
                let urls = []
                for (let i = 0; i < url.length; i++) {
                    let response = url[i].response
                    if (response && response.flag === 1) {
                        urls.push(response.data.url)
                    }
                }
                params.url = urls.join(':::')
                let { is_edit } = this.props, result = {}
                if (is_edit) {
                    params.id = is_edit
                    result = await app.post(api.PpeEdit, params)
                } else {
                    result = await app.post(api.PpeAdd, params)
                }
                let state = { submit_loading: false }
                if (result.flag === 1) {
                    app.alert('等待审核~', "success")
                    await this.setData(state)
                    this.props.success()
                } else {
                    app.alert(result.msg, "error")
                    await this.setData(state)
                }
            }
        })
    }

    /**
     * 发证机构
     * @constructor
     */
    PpeOrganizationSource = async (class_id) => {
        await this.setData({ org_loading: true, organizationList: [] })
        let params = {
            class_id,
            indexno: app.getData('indexno'),
            account: app.getData('account'),
        }
        let { flag, data, msg } = await app.post(api.OListing, params)
        if (flag !== 1) {
            app.alert(msg, "error")
            data = []
        }
        await this.setData({ organizationList: data, org_loading: false })
    }

    /**
     * 变更技能选择处理
     * @param value
     */
    handlePPeChange = async (value) => {
        await this.PpeOrganizationSource(value[0])
    }

    render () {
        let { is_edit, form, ppeTypeList, info } = this.props,
            { organizationList, org_loading, submit_loading } = this.state,
            { getFieldDecorator, getFieldValue } = form,
            formItemLayout = {
                labelCol: { span: 6 },
                wrapperCol: { span: 13, offset: 1 }
            }
        return (
            <div>
                <Form onSubmit={this.handleSubmit}>
                    <FormItem
                        {...formItemLayout}
                        label="选择技能"
                    >
                        {getFieldDecorator("ppe_id", {
                            rules: [{ required: true, message: '请选择技能!' }],
                            initialValue: info.ppe_id,
                        })(
                            <Cascader placeholder="请选择要添加的技能"
                                      options={ppeTypeList}
                                      fieldNames={{
                                          label: 'names',
                                          value: 'id',
                                          children: 'subclass'
                                      }}
                                      notFoundContent="无记录"
                                      displayRender={label => label[label.length - 1]}
                                      onChange={this.handlePPeChange}
                                      showSearch
                                      disabled={is_edit ? true : false}
                                      allowClear/>
                        )}
                    </FormItem>
                    <FormItem
                        {...formItemLayout}
                        label="认证机构"
                    >
                        {getFieldDecorator("organization_id", {
                            rules: [{ required: true, message: '请选择认证机构!' }],
                            initialValue: org_loading ? undefined : (info.organization_id || undefined),
                        })(
                            <Select
                                showSearch
                                allowClear
                                style={{ width: '100%' }}
                                placeholder="请选择认证机构"
                                optionFilterProp="children"
                                notFoundContent={org_loading ? <Spin size="small"/> : "暂无记录"}
                            >
                                {
                                    organizationList.map((org, i) => {
                                        return (
                                            <Option key={i} value={org.id}>{org.organization_name}</Option>
                                        )
                                    })
                                }
                            </Select>
                        )}
                    </FormItem>
                    <FormItem
                        {...formItemLayout}
                        label="获证日期"
                    >
                        {getFieldDecorator("get_time", {
                            rules: [{ required: true, message: '请选择获证日期!' }],
                            initialValue: info.datetime ? moment(info.datetime) : undefined
                        })(
                            <DatePicker locale={mlocale} disabledDate={(current) => {
                                return current && current > moment().endOf('day')
                            }} allowClear/>
                        )}
                    </FormItem>
                    <FormItem
                        {...formItemLayout}
                        label="获证期限"
                    >
                        {getFieldDecorator("is_long", {
                            rules: [{ required: true, message: '请选择技能时效!' }],
                            initialValue: info.is_long || undefined
                        })(
                            <RadioGroup>
                                <Radio value="1">有效期</Radio>
                                <Radio value="2">长期 / 无有效期</Radio>
                            </RadioGroup>
                        )}
                    </FormItem>
                    {
                        getFieldValue('is_long') === '1' ? (
                            <FormItem
                                {...formItemLayout}
                                label="到期日期"
                            >
                                {getFieldDecorator("expire_time", {
                                    rules: [{ required: true, message: '请选择到期日期!' }],
                                    initialValue: info.expire_time ? moment(info.expire_time) : undefined
                                })(
                                    <DatePicker locale={mlocale} allowClear/>
                                )}
                            </FormItem>
                        ) : null
                    }
                    <FormItem
                        labelCol={{ span: 6 }}
                        wrapperCol={{ span: 17, offset: 1 }}
                        label="技能证书"
                    >
                        {getFieldDecorator("url", {
                            valuePropName: 'fileList',
                            getValueFromEvent: e => {
                                if (Array.isArray(e)) {
                                    return e
                                }
                                return e && e.fileList
                            },
                            rules: [{ required: true, message: '请上传技能证书!' }],
                            initialValue: (info.images || []).map((img, i) => {
                                i += 1
                                return {
                                    uid: i - i * 2,
                                    status: 'done',
                                    response: {
                                        flag: 1,
                                        data: {
                                            url: img
                                        }
                                    },
                                    name: "图片" + i,
                                    thumbUrl: config.imgUrl + img
                                }
                            })
                        })(
                            <Upload
                                accept='image/jpeg, image/jpg, image/png'
                                action={config.serverUrl + api.ImageUpload}
                                listType="picture"
                                beforeUpload={beforeUpload}
                                data={{
                                    token: app.getData('token'),
                                    indexno: app.getData('indexno'),
                                    account: app.getData('account'),
                                    upload_type: 'ppe'
                                }}
                                name="image"
                                className="upload-list-inline"
                            >
                                <Button>上传图片</Button>
                            </Upload>
                        )}
                    </FormItem>
                    <Row>
                        <Col offset={7} style={{ color: 'red', lineHeight: '20px' }}>
                            <div>注：技能信息编辑后需要管理员重新审核。</div>
                        </Col>
                    </Row>
                    <FormItem wrapperCol={{ span: 8, offset: 7 }}>
                        <Button type="primary" loading={submit_loading} style={{ marginTop: 15 }}
                                htmlType="submit" block>提交</Button>
                    </FormItem>
                </Form>
            </div>
        )
    }
}

export default Form.create()(PpeAdd)



// WEBPACK FOOTER //
// ./src/routes/playerInfo/PpeAdd.jsx